export default __webpack_public_path__ + "static/media/img3.68d4216f.png";